// import React from "react";
// import "../product.scss"; // Import the CSS file
// import Select from "react-select";
// import { useSelector } from "react-redux";
// import { oemToBenefitMappping } from "../ProductService";
// import { useEffect } from "react";

// const OemBenefits = () => {
//   const oemBenefitsData = useSelector(
//     (state) => state.product.selectedProduct.oemBenefits.oemBenefitsData
//   );
//   const data = useSelector(
//     (state) => state.product.selectedProduct.detailsData
//   );

//   const customSelect = {
//     control: (provided) => ({
//       ...provided,
//       fontSize: "14px",
//       minHeight: "40px",
//       borderRadius: "4px",
//       boxShadow: "none",
//       width: "100%",
//       "&:hover": {},
//       "&:focus": {},
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       // zIndex: 9999, // Adjust the z-index as needed
//     }),

//     indicatorSeparator: () => ({
//       display: "none",
//     }),
//   };

//   useEffect(() => {
//     oemToBenefitMappping(data.entityid, data.organizationid);
//   }, [data.entityid, data.organizationid]);

//   const selectOptions = [
//     { label: "Yes", value: "yes" },
//     { label: "No", value: "no" },
//   ];

//   const oemNames = oemBenefitsData[0]?.psp_oem?.map((oem) => oem.name);

//   const renderOemCells = (benefit) => {
//     return oemBenefitsData[0]?.psp_oem?.map((oem, oemIndex) => {
//       let cellContent = null;
//       if (benefit.type === "BOOLEAN") {
//         // Render select dropdown for BOOLEAN type
//         cellContent = (
//           <Select
//             placeholder="Select"
//             name="name"
//             options={selectOptions}
//             styles={customSelect}
//             // onChange={handleStatusChange}
//             menuPortalTarget={document.body}
//             // value={
//             //   selectOptions?.filter(
//             //     (itm) => itm?.value === filterForm?.name
//             //   ) || ""
//             // }
//             required
//             // onChange={(e) =>
//             //   dispatch(
//             //     setMerchantFilterForm({
//             //       name: "name",
//             //       value: e.value,
//             //     })
//             //   )
//             // }
//           />
//         );
//       } else if (benefit.type === "NUMBER") {
//         // Render input field for NUMBER type
//         cellContent = (
//           <input
//             type="text"
//             placeholder="Enter"
//             className="form-control"
//             defaultValue={oem.benefit_value}
//           />
//         );
//       } else {
//         cellContent = "N/A"; // Handle other types as needed
//       }
//       return (
//         <td key={oemIndex} className="col-oem">
//           {cellContent}
//         </td>
//       );
//     });
//   };

//   return (
//     <div>
//       <div className="oem-benefits-container">
//         <table className="oem-benefits-table">
//           <thead>
//             <tr>
//               <th className="col-benefit fixed-col">Benefit</th>
//               {oemNames?.map((name, index) => (
//                 <th key={index} className="col-oem">
//                   {name}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {oemBenefitsData.map((benefit, index) => (
//               <tr key={index}>
//                 <td className="fixed-col">{benefit.name}</td>
//                 {renderOemCells(benefit)}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="table-button-wrapper">
//         <button type="submit" className="btn btn-outline-primary cancel">
//           Cancel
//         </button>
//         <button
//           type="submit"
//           className="btn btn-primary save"
//           id="addNewMember"
//         >
//           Save
//         </button>
//       </div>
//     </div>
//   );
// };

// export default OemBenefits;

// import React, { useState, useEffect } from "react";
// import "../product.scss"; // Import the CSS file
// import Select from "react-select";
// import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
// import {
//   oemToBenefitMappping,
//   productBenefitToOemMapping,
// } from "../ProductService";

// const OemBenefits = () => {
//   const dispatch = useDispatch();
//   const oemBenefitsData = useSelector(
//     (state) => state.product.selectedProduct.oemBenefits.oemBenefitsData
//   );
//   const data = useSelector(
//     (state) => state.product.selectedProduct.detailsData
//   );

//   const customSelect = {
//     control: (provided) => ({
//       ...provided,
//       fontSize: "14px",
//       minHeight: "40px",
//       borderRadius: "4px",
//       boxShadow: "none",
//       width: "100%",
//     }),
//     menuPortal: (base) => ({
//       ...base,
//     }),
//     indicatorSeparator: () => ({
//       display: "none",
//     }),
//   };

//   useEffect(() => {
//     oemToBenefitMappping(data.entityid, data.organizationid);
//   }, [data.entityid, data.organizationid]);

//   const selectOptions = [
//     { label: "Yes", value: "TRUE" },
//     { label: "No", value: "FALSE" },
//   ];

//   const oemNames = oemBenefitsData[0]?.psp_oem?.map((oem) => oem.name);

//   const [benefitValues, setBenefitValues] = useState({});

//   const handleSelectChange = (benefitId, oemId, selectedOption) => {
//     setBenefitValues((prevValues) => ({
//       ...prevValues,
//       [`${benefitId}-${oemId}`]: selectedOption.value,
//     }));
//   };

//   const handleInputChange = (benefitId, oemId, event) => {
//     setBenefitValues((prevValues) => ({
//       ...prevValues,
//       [`${benefitId}-${oemId}`]: event.target.value,
//     }));
//   };

//   const handleSave = () => {
//     const payload = oemBenefitsData.flatMap((benefit) =>
//       benefit.psp_oem.map((oem) => ({
//         product_id: benefit.product_id,
//         benefit_id: benefit.entityid,
//         oem_id: oem.entityid,
//         value: benefitValues[`${benefit.entityid}-${oem.entityid}`] || null,
//       }))
//     );

//     // Example of ensuring immutability

//     productBenefitToOemMapping(payload);
//   };

//   const renderOemCells = (benefit) => {
//     return oemBenefitsData[0]?.psp_oem?.map((oem, index) => {
//       let cellContent = null;
//       if (benefit.type === "BOOLEAN") {
//         const selectedOption = selectOptions.find(
//           (option) =>
//             option.value ===
//             benefitValues[`${benefit.entityid}-${oem.entityid}`]
//         );

//         cellContent = (
//           <Select
//             name="benefit_value"
//             options={selectOptions}
//             value={selectOptions.find((opt) => opt.value === oem.benefit_value)}
//             onChange={(selectedOption) =>
//               handleSelectChange(benefit.entityid, oem.entityid, selectedOption)
//             }
//             styles={customSelect}
//           />
//         );
//       } else if (benefit.type === "NUMBER") {
//         cellContent = (
//           <input
//             type="number"
//             placeholder="Enter"
//             className="form-control"
//             name="benefit_value"
//             defaultValue={oem.benefit_value}
//             onChange={(event) =>
//               handleInputChange(benefit.entityid, oem.entityid, event)
//             }
//           />
//         );
//       } else {
//         cellContent = "N/A"; // Handle other types as needed
//       }
//       return <td key={`${benefit.entityid}-${index}`}>{cellContent}</td>;
//     });
//   };

//   return (
//     <div>
//       <div className="oem-benefits-container">
//         <table className="oem-benefits-table">
//           <thead>
//             <tr>
//               <th className="col-benefit fixed-col">Benefit</th>
//               {oemNames?.map((oemName, index) => (
//                 <th key={index} className="col-oem">
//                   {oemName}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {oemBenefitsData.map((benefit) => (
//               <tr key={benefit.entityid}>
//                 <td className="fixed-col">{benefit.name}</td>
//                 {renderOemCells(benefit)}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         <div className="table-button-wrapper">
//           <button type="submit" className="btn btn-outline-primary cancel">
//             Cancel
//           </button>
//           <button
//             type="submit"
//             className="btn btn-primary save"
//             id="addNewMember"
//             onClick={handleSave}
//           >
//             Save
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OemBenefits;

import React, { useState, useEffect } from "react";
import "../product.scss"; // Import the CSS file
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import {
  oemToBenefitMappping,
  productBenefitToOemMapping,
} from "../ProductService";

const OemBenefits = () => {
  const dispatch = useDispatch();
  const oemBenefitsData = useSelector(
    (state) => state.product.selectedProduct.oemBenefits.oemBenefitsData
  );
  const data = useSelector(
    (state) => state.product.selectedProduct.detailsData
  );

  const customSelect = {
    control: (provided) => ({
      ...provided,
      fontSize: "14px",
      minHeight: "40px",
      borderRadius: "4px",
      boxShadow: "none",
      width: "100%",
    }),
    menuPortal: (base) => ({
      ...base,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  useEffect(() => {
    oemToBenefitMappping(data.entityid, data.organizationid);
  }, [data.entityid, data.organizationid]);

  const selectOptions = [
    { label: "Yes", value: "TRUE" },
    { label: "No", value: "FALSE" },
  ];

  const oemNames = oemBenefitsData[0]?.psp_oem?.map((oem) => oem.name);

  const [benefitValues, setBenefitValues] = useState({});

  useEffect(() => {
    const initialValues = {};
    oemBenefitsData.forEach((benefit) => {
      benefit.psp_oem.forEach((oem) => {
        initialValues[`${benefit.entityid}-${oem.entityid}`] =
          oem.benefit_value;
      });
    });
    setBenefitValues(initialValues);
  }, [oemBenefitsData]);

  const handleSelectChange = (benefitId, oemId, selectedOption) => {
    setBenefitValues((prevValues) => ({
      ...prevValues,
      [`${benefitId}-${oemId}`]: selectedOption.value,
    }));
  };

  const handleInputChange = (benefitId, oemId, event) => {
    setBenefitValues((prevValues) => ({
      ...prevValues,
      [`${benefitId}-${oemId}`]: event.target.value,
    }));
  };

  const handleSave = () => {
    const payload = oemBenefitsData.flatMap((benefit) =>
      benefit.psp_oem.map((oem) => ({
        product_id: benefit.product_id,
        benefit_id: benefit.entityid,
        oem_id: oem.entityid,
        value: benefitValues[`${benefit.entityid}-${oem.entityid}`] || null,
      }))
    );

    productBenefitToOemMapping(payload);
  };

  const renderOemCells = (benefit) => {
    return oemBenefitsData[0]?.psp_oem?.map((oem, index) => {
      let cellContent = null;
      if (benefit.type === "BOOLEAN") {
        const selectedOption = selectOptions.find(
          (option) =>
            option.value ===
            benefitValues[`${benefit.entityid}-${oem.entityid}`]
        );

        cellContent = (
          <Select
            name="benefit_value"
            options={selectOptions}
            value={selectedOption}
            onChange={(selectedOption) =>
              handleSelectChange(benefit.entityid, oem.entityid, selectedOption)
            }
            styles={customSelect}
          />
        );
      } else if (benefit.type === "NUMBER") {
        cellContent = (
          <input
            type="number"
            placeholder="Enter"
            className="form-control"
            name="benefit_value"
            value={benefitValues[`${benefit.entityid}-${oem.entityid}`] || ""}
            onChange={(event) =>
              handleInputChange(benefit.entityid, oem.entityid, event)
            }
          />
        );
      } else {
        cellContent = "N/A"; // Handle other types as needed
      }
      return <td key={`${benefit.entityid}-${index}`}>{cellContent}</td>;
    });
  };

  return (
    <div className="oem-benefits">
      <div className="oem-benefits-container">
        <table className="oem-benefits-table">
          <thead>
            <tr>
              <th width="200px" className="col-benefit fixed-col">Benefit</th>
              {oemNames?.map((oemName, index) => (
                <th key={index} className="col-oem">
                  {oemName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {oemBenefitsData.map((benefit) => (
              <tr key={benefit.entityid}>
                <td className="fixed-col">{benefit.name}</td>
                {renderOemCells(benefit)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="table-button-wrapper">
        <button type="submit" className="btn btn-outline-primary cancel">
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary save"
          id="addNewMember"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default OemBenefits;
